import * as React from "react";

import * as styles from './style.css';

const Llama = require('./icons/spinner-llama.png');
const Plus = require('./icons/spinner-plus.png');
// const Gift = require('./icons/spinner-gift.png');
const QR = require('./icons/spinner-qr.png');
const Equal = require('./icons/spinner-equal.png');
const Heart = require('./icons/spinner-heart.png');

class LayoutComponentsSpinner extends React.PureComponent {
  
  lastStep = 4;
  interval = 340;
  duration = 500;
  durationTimer = null;
  animationTimer = null;
  
  constructor(props) {
    super(props);
    this.state = {
      step: 0
    }
  }
  
  componentDidMount() {
    this.startAnimation();
  }
  
  componentWillUnmount() {
    this.stopAnimation();
  }

  startAnimation = () => {
    this.setState({ step: 0 });
    this.animationTimer = setInterval(() => {
      let nextStep;
      if (this.state.step === this.lastStep) {
        nextStep = -1;
        this.stopAnimation();
        this.durationTimer = setTimeout(() => {
          this.startAnimation();
          this.durationTimer = null;
        }, this.duration);
      } else {
        nextStep = this.state.step + 1;
      }

      this.setState({ step: nextStep });
    }, this.interval);
  };

  stopAnimation = () => {
    if (this.animationTimer) {
      clearInterval(this.animationTimer);
      this.animationTimer = null;
    }
    if (this.durationTimer) {
      clearTimeout(this.durationTimer);
      this.durationTimer = null;
    }
  };

  getIconOpacity = (iconIndex) => {
    return iconIndex <= this.state.step ? 1 : 0;
  };

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.inner}>
          <img src={Llama}
               style={{ opacity: this.getIconOpacity(0) }}     
               className={styles.icon} />
          <img src={Plus}
               style={{ opacity: this.getIconOpacity(1) }}     
               className={styles.iconMath} />
          <img src={QR}
               style={{ opacity: this.getIconOpacity(2) }}     
               className={styles.icon} />
          <img src={Equal}
               style={{ opacity: this.getIconOpacity(3) }}
               className={styles.iconMath} />
          <img src={Heart}
               style={{ opacity: this.getIconOpacity(4) }}     
               className={styles.icon} />
        </div>
      </div>
    );
  }
}

export default LayoutComponentsSpinner;


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/spinner/index.jsx